import { render, staticRenderFns } from "./AddComment.vue?vue&type=template&id=83ea4680&scoped=true&"
import script from "./AddComment.vue?vue&type=script&lang=js&"
export * from "./AddComment.vue?vue&type=script&lang=js&"
import style0 from "./AddComment.vue?vue&type=style&index=0&id=83ea4680&scoped=true&lang=css&"
import style1 from "./AddComment.vue?vue&type=style&index=1&id=83ea4680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ea4680",
  null
  
)

export default component.exports